import * as React from 'react';

import DecimalInput, { DEFAULT_DECIMAL } from '~/UI/Input/DecimalInput';
import { PriceOriginDotMark } from './PriceOriginDotMark';

interface PriceVolumeGrowthPriceInputProps {
	userDefined: boolean;
	showEditing: boolean;
	value: number | string | null | undefined;
	onChange: (nextValue: string) => void;
	onEditingSet: () => void;
	error?: boolean;
}

export function PriceVolumeGrowthPriceInput({
	showEditing,
	userDefined,
	value,
	onChange,
	onEditingSet,
	error,
}: PriceVolumeGrowthPriceInputProps) {
	const hasPrice = !(value == null || typeof value === 'undefined');
	const actualShow = showEditing || !hasPrice;

	return (
		<>
			<PriceOriginDotMark price={value} userDefined={userDefined} />
			{actualShow ? (
				<DecimalInput
					allowEmpty
					selectOnFocus
					autoFocus={showEditing}
					className={`w-full px-1.5 py-1 font-display text-label text-black font-semibold leading-4 border ${
						error ? 'border-red-500' : 'border-gray-300'
					} rounded tabular-nums bg-white`}
					value={value || ''}
					onDecimalInput={(nextValue) => {
						onEditingSet();
						onChange(nextValue);
					}}
					hasError={error}
				/>
			) : (
				<span className='font-display text-label font-semibold text-gray-500 leading-none whitespace-nowrap'>
					{Number(value).toFixed(DEFAULT_DECIMAL)}
				</span>
			)}
			{!actualShow && (
				<button
					className='grow w-full font-display text-labelsmall font-semibold text-cPurple-600 leading-none whitespace-nowrap text-right'
					type='button'
					onClick={() => onEditingSet()}
				>
					edit
				</button>
			)}
		</>
	);
}
